<div class="footer">
  <div class="container">
    <div class="copyright">
      {{ 'FOOTER.COPYRIGHT' | translate | format:year }}
    </div>
  </div>
</div>
